import { render, staticRenderFns } from "./SettingTaxAutoModal.vue?vue&type=template&id=8b41c978&scoped=true&"
import script from "./SettingTaxAutoModal.vue?vue&type=script&lang=js&"
export * from "./SettingTaxAutoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b41c978",
  null
  
)

export default component.exports